import React from "react";
import {bindActionCreators} from "redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import GameComponent from "game/app/components/game/game-component";
import {Tooltip} from "reactstrap";
import QuestionForm from "../../../common/question-form";
import assets from 'game/app/assets';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {push} from "react-router-redux";
import VideoBtn from "game/app/components/video-btn";

class MainComponent extends GameComponent {

    constructor(props) {
        super(props);
        this.state = {
            tooltipHousingInsuranceOpen: false,
            tooltipTransportationOpen: false,
            tooltipTransportationInsuranceOpen: false,
        };
    }

    toggleHousingInsuranceTooltip = () => { this.setState({...this.state, tooltipHousingInsuranceOpen: !this.state.tooltipHousingInsuranceOpen }) };
    toggleTransportationTooltip = () => { this.setState({...this.state, tooltipTransportationOpen: !this.state.tooltipTransportationOpen }) };
    toggleTransportationInsuranceTooltip = () => { this.setState({...this.state, tooltipTransportationInsuranceOpen: !this.state.tooltipTransportationInsuranceOpen }) };

    sendAnswer = (values, form) => {
        this.props.sendInput(this.getInstanceId(), { type: 'answer', answer: values });
    };

    profileQuestions() {
        if (this.props.knowledgeQuestions === null || this.props.knowledgeQuestions.loading) return (<div/>);

        let round_01_id = this.getNodeId('Nodes::Round01Node');
        let current_round = this.isCurrentNodeType('Nodes::Round01Node');
        let instance_id = this.getInstanceId();
        let answers = this.props.gameInstance.instance.answers;

        return this.props.knowledgeQuestions.list.filter((question) => question.properties['game_node_id'] === round_01_id).map((question) => {
            let answer = answers.find((answer) => answer.luduengine_knowledge_question_id === question.id);
            return (<QuestionForm key={question.id} className='question' question={question} answer={answer} handleSubmit={this.sendAnswer} active={current_round} instanceId={instance_id} />)
        });
    }

    finalizeProfile = () => {
        this.props.sendInput(this.getInstanceId(), { type: 'finalize_profile' }).then(() => {
            this.props.push(`/game/${this.getInstanceId()}/round-1/otazky`);
        });
    };

    render() {
        let food = this.getFood();
        let housing = this.getHousing();
        let housingInsurance = this.getHousingInsurance();
        let transportation = this.getTransportation();
        let transportationInsurance = this.getTransportationInsurance();
        let currentRound = this.isCurrentNodeType('Nodes::Round01Node');
        let profileFinished = this.getInstanceProperty('PROFILE_FINISHED');
        let profileComplete = this.getInstanceProperty('PROFILE_COMPLETE');
        let transportationInsuranceShow = transportation && transportation['insurance'] && transportation['insurance'].length !== 0;
        let moneyLimitOk = this.getInstanceProperty('STATS_MONEY') >= 45000;

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1 className='page-title-minor separate-bottom'>Profil domácnosti</h1>
                        <div id="family-profile" className='card'>
                            <div className='left-side'>
                                <p><img src={assets.profil} className='img-fluid'/></p>
                                <p><strong>{ this.getProfileProperty('category') }<br/>{ this.getProfileProperty('name') }</strong></p>
                                <p>{ this.getProfileProperty('long_desc') }</p>
                                <p>Počáteční rezerva: { this.getInstanceProperty('INITIAL_RESERVE').toLocaleString(this.locale) } Kč</p>
                            </div>
                            <div className='right-side'>
                                { this.getProfile()['properties']['members'].map((member, index) => {
                                    return (<div className='member' key={index}><div className='label'>{ member['name'] }</div><div>Příjem: { member['income'].toLocaleString(this.locale) } Kč<br/>{ member['income_desc'] }</div></div>);
                                }) }
                            </div>
                        </div>
                        <h2 className='page-title-minor-minor text-center separate' id='profil'>Základní výdaje</h2>
                        <div className='separate text-center'>
                            <p>Podívej se na video jak správně nastavit jednotlivé kategorie.</p>
                            <VideoBtn videoId='JUVGg5oT6jk'><FontAwesomeIcon icon={['fas', 'play']} /> Bydlení a doprava</VideoBtn> <VideoBtn videoId='g9vJH5wA1dk'><FontAwesomeIcon icon={['fas', 'play']} /> Jídlo</VideoBtn>
                        </div>
                        <div id="round-1-expenses" className='text-center separate-bottom'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-xl-3'>
                                            <img src={assets.bydleni} className='img-fluid'/>
                                        </div>
                                        <div className='col-xl-9 text-left'>
                                            <h5 className='text-uppercase'>Bydlení</h5>
                                            <div className='row'>
                                                <div className={ currentRound && !profileFinished ? 'col-xl-8' : 'col-xl-12' }>
                                                    <span style={{'whiteSpace': 'pre-line'}}>{ housing ? housing['description'] : 'Jak budete bydlet? V bytě ve městě, nebo radši v domě na venkově? Vyberte si bydlení, které vám bude nejvíc vyhovovat.' }</span>
                                                </div>
                                                {currentRound && !profileFinished &&
                                                <div className='col-xl-4'>
                                                    {housing && <Link to={`/game/${this.getInstanceId()}/round-1/bydleni`} className='btn btn-block btn-success'><FontAwesomeIcon icon={['far','check']}/></Link>}
                                                    {!housing && <Link to={`/game/${this.getInstanceId()}/round-1/bydleni`} className='btn btn-block btn-primary'>Zvolit</Link>}
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className='row'>
                                        <div className='col-xl-3'>
                                        </div>
                                        <div className='col-xl-9 text-left'>
                                            <p className='label'>Pojištení</p>
                                            <div className='row'>
                                                <div className={ currentRound && !profileFinished ? 'col-xl-8' : 'col-xl-12' }>
                                                    <span style={{'whiteSpace': 'pre-line'}}>{ housingInsurance ? housingInsurance['description'] : 'Zvolte pojištení bydlení' }</span>
                                                </div>
                                                {currentRound && !profileFinished &&
                                                <div className='col-xl-4'>
                                                    <div>
                                                        {housing && housingInsurance && <Link to={`/game/${this.getInstanceId()}/round-1/bydleni-pojisteni`} className='btn btn-block btn-success'><FontAwesomeIcon icon={['far','check']}/></Link>}
                                                        {housing && !housingInsurance && <Link to={`/game/${this.getInstanceId()}/round-1/bydleni-pojisteni`} className='btn btn-block btn-primary'>Zvolit</Link>}
                                                        {!housing && <span id="housingInsuranceDisabled" className='btn btn-block btn-primary disabled'>Zvolit</span> }
                                                        {!housing && <Tooltip placement="bottom" isOpen={this.state.tooltipHousingInsuranceOpen} target="housingInsuranceDisabled" toggle={this.toggleHousingInsuranceTooltip}>Musíte zvolit bydlení</Tooltip>}
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-xl-3'>
                                            <img src={assets.jidlo} className='img-fluid'/>
                                        </div>
                                        <div className='col-xl-9 text-left'>
                                            <h5 className='text-uppercase'>Jídlo</h5>
                                            <div className='row'>
                                                <div className={ currentRound && !profileFinished ? 'col-xl-8' : 'col-xl-12' }>
                                                    <span style={{'whiteSpace': 'pre-line'}}>{ food ? food['description'] : 'Zvolte si, jak se budou členové vaší domácnosti převážně stravovat. Dobré jídlo je důležité pro zdraví i pro naši spokojenost, tak to dobře zvažte.' }</span>
                                                </div>
                                                {currentRound && !profileFinished &&
                                                <div className='col-xl-4'>
                                                    {food && <Link to={`/game/${this.getInstanceId()}/round-1/food`} className='btn btn-block btn-success'><FontAwesomeIcon icon={['far','check']}/></Link>}
                                                    {!food && <Link to={`/game/${this.getInstanceId()}/round-1/food`} className='btn btn-block btn-primary'>Zvolit</Link>}
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-xl-3'>
                                            <img src={assets.doprava} className='img-fluid'/>
                                        </div>
                                        <div className='col-xl-9 text-left'>
                                            <h5 className='text-uppercase'>Doprava</h5>
                                            <div className='row'>
                                                <div className={ currentRound && !profileFinished ? 'col-xl-8' : 'col-xl-12' }>
                                                    <span style={{'whiteSpace': 'pre-line'}}>{ transportation ? transportation['description'] : 'Dopravovat se můžete mnoha způsoby. Jaký je ve vašem případě ten pravý?' }</span>
                                                </div>
                                                {currentRound && !profileFinished &&
                                                <div className='col-xl-4'>
                                                    {housing && transportation && <Link to={`/game/${this.getInstanceId()}/round-1/transportation`} className='btn btn-block btn-success'><FontAwesomeIcon icon={['far','check']}/></Link>}
                                                    {housing && !transportation && <Link to={`/game/${this.getInstanceId()}/round-1/transportation`} className='btn btn-block btn-primary'>Zvolit</Link>}
                                                    {!housing && <span id="transportationDisabled" className='btn btn-block btn-primary disabled'>Zvolit</span> }
                                                    {!housing && <Tooltip placement="bottom" isOpen={this.state.tooltipTransportationOpen} target="transportationDisabled" toggle={this.toggleTransportationTooltip}>Musíte zvolit bydlení</Tooltip>}
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {transportationInsuranceShow &&
                                        <div>
                                            <hr/>
                                            <div className='row'>
                                                <div className='col-xl-3'>
                                                </div>
                                                <div className='col-xl-9 text-left'>
                                                    <p className='label'>Pojištení</p>
                                                    <div className='row'>
                                                        <div
                                                            className={currentRound && !profileFinished ? 'col-xl-8' : 'col-xl-12'}>
                                                            <span style={{'whiteSpace': 'pre-line'}}>{transportationInsurance ? transportationInsurance['description'] : 'Zvolte pojištení dopravy'}</span>
                                                        </div>
                                                        {currentRound && !profileFinished &&
                                                        <div className='col-xl-4'>
                                                            <div>
                                                                {transportation && transportationInsurance && <Link to={`/game/${this.getInstanceId()}/round-1/transportation-pojisteni`} className='btn btn-block btn-success'><FontAwesomeIcon icon={['far', 'check']}/></Link>}
                                                                {transportation && !transportationInsurance && <Link to={`/game/${this.getInstanceId()}/round-1/transportation-pojisteni`} className='btn btn-block btn-primary'>Zvolit</Link>}
                                                                {!transportation && <span id="housingInsuranceDisabled" className='btn btn-block btn-primary disabled'>Zvolit</span>}
                                                                {!transportation && <Tooltip placement="bottom" isOpen={this.state.tooltipHousingInsuranceOpen} target="housingInsuranceDisabled" toggle={this.toggleHousingInsuranceTooltip}>Musíte zvolit typ dopravy</Tooltip>}
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        { !profileFinished &&
                        <div className='card'>
                            <div className='card-body text-center'>
                                <p><strong>Minimální částka cashflow (Peníze) pro ukončení výběru základních výdajů je 45 000 Kč.</strong></p>
                                { currentRound && !profileFinished && ( !profileComplete || !moneyLimitOk )&& <span className='btn btn-block btn-secondary disabled'>Ukončit výběr základních výdajů</span> }
                                { currentRound && !profileFinished && profileComplete && moneyLimitOk && <button className='btn btn-block btn-primary' onClick={this.finalizeProfile}>Ukončit výběr základních výdajů</button> }
                            </div>
                        </div>
                        }
                    </div>

                </div>
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        push: push
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(MainComponent);
